import * as React from 'react';
import { useEffect, useState } from 'react';

import { Button, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { UpdateTabsEvent } from './UpdateTabsEvent';
import { ChangedTabEvent } from './ChangedTabEvent';

import "./NavigationTabsStyles.css";


export interface INavigationTabsProps {
    initSelectedTab: 0|1|2;
    updateView: (target: 0|1|2) => void;
}

const useStyles = makeStyles({
    activeTab: {
        background: (props: any) => props.white,
        boxShadow: "none",
        color: (props: any) => props.red,
        '&:hover': {
            background: (props: any) => props.white,
            borderColor: (props: any) => props.white,
            boxShadow: "none",
            color: (props: any) => props.red,
        }
    },
    inactiveTab: {
        background: (props: any) => props.red,
        borderColor: (props: any) => props.white,
        color: (props: any) => props.white,
        '&:hover': {
            background: (props: any) => props.white,
            boxShadow: "none",
            color: (props: any) => props.red,
        }
    }
})

const NavigationTabs = (props: INavigationTabsProps) => {
    const { initSelectedTab, updateView } = props;
    const { activeTab, inactiveTab } = useStyles({
        red: "#d32f2f",
        white: "#ffffff",
    });

    const [tab, setTab] = useState<0|1|2>(initSelectedTab)

    useEffect(() => {
        window.addEventListener("tabUpdate", (event: UpdateTabsEvent) => handleTabUpdateEvent(event));

        return(
            window.removeEventListener("tabUpdate", (event: UpdateTabsEvent) => handleTabUpdateEvent(event))
        )
    }, [])

    const handleTabUpdateEvent = (event: UpdateTabsEvent) => {
        setTab(event.tabIndex);
    }

    const handleTabsClick = (target: 0|1|2) => {
        setTab(target);
        updateView(target);
        
        window.dispatchEvent(new ChangedTabEvent(target));
    }

    return(
        <Grid className="tabs-container" alignItems="center" container columns={3} direction="row" justifyContent="center">
            <Grid className="tabs-item" id="tabs-item-1" item xs={1}>
                <Button className={tab === 0 ? activeTab : inactiveTab} onClick={() => {handleTabsClick(0)}} variant="outlined">Das Projekt</Button>
            </Grid>
            <Grid className="tabs-item" item xs={1}>
                <Button className={tab === 1 ? activeTab : inactiveTab} onClick={() => {handleTabsClick(1)}} variant="outlined">Videos</Button>
            </Grid>
            <Grid className="tabs-item" item xs={1}>
                <Button className={tab === 2 ? activeTab : inactiveTab} onClick={() => {handleTabsClick(2)}} variant="outlined">Downloads</Button>
            </Grid>
        </Grid>
    );
}

export default NavigationTabs;